<template>
  <asc-dialog
    :show-dialog="showDialog"
    :text="getDialogTitle"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-connectivity
        :days="days"
        :tail-number="tailNumber"
        :loading="loading"
      ></asc-connectivity>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscConnectivity from './AscConnectivity'

export default {
  name: 'AscConnectivityDialog',

  components: {
    AscDialog,
    AscConnectivity,
  },

  mixins: [AscDialogMixin],

  props: {
    days: {
      type: Number,
      default: 0,
    },
    tailNumber: {
      type: String,
      default: '',
    },
  },

  computed: {
    getDialogTitle() {
      return `Connectivity for ${this.tailNumber}`
    },
  },
}
</script>
